import { SplitContext, useSplitTreatments } from "@splitsoftware/splitio-react"
import { useContext } from "react"
import { FeatureFlag } from "./feature-flag"

export function useFeatureFlag(
  flagName: FeatureFlag,
  splitCustomerKey?: number | undefined
): [string, { isReady: boolean; isControl: boolean; isFeatureFlagEnabled: boolean; featureFlagValue: string }] {
  const { isReady } = useContext(SplitContext)

  const { treatments } = useSplitTreatments({
    names: [flagName],
    splitKey: splitCustomerKey ? String(splitCustomerKey) : undefined // use default key from cookie if not provided
  })
  const featureFlag = treatments[flagName].treatment
  const isFeatureFlagEnabled = featureFlag === "on"

  return [
    featureFlag,
    { isReady, isControl: featureFlag === "control", isFeatureFlagEnabled, featureFlagValue: featureFlag }
  ]
}
